import React from 'react'
import {
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import useSWR from "swr";
import {
  api,
  IconAbajo,
  PortalContext
} from "@portal/arq-portal-core";

const useStyles = makeStyles({
  rootPanel: {
    '@media screen and (max-width: 959px)': {
      display: 'none'
    }
  },
  root: {
    display: 'flex',
    padding: '5px',
    fontSize: 12,
    color: '#6D6D6D',
    justifyContent: 'flex-end',
    marginTop: 10,
    '@media screen and (max-width: 959px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: 0,
      padding: '0 36px'
    }
  },
  titulo: {
    fontWeight: 'bold',
    color: '#DC0028',
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2px',
  },
  linea: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center'
  },
  monto: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center'
  },
  menuSeccion: {
    display: 'flex',
    marginBottom: '2px',
  },
  positive: {
    position:'relative',
    marginRight: 8,
    '&::before': {
      content: '""',
      width: 0,
      height: 0,     
      borderLeft: '0.4em solid transparent',
      borderRight: '0.4em solid transparent',
      borderBottom: '0.7em solid #14A843',
      marginRight: 3,
      marginBottom: '1px',
    }
  },
  negative: {
    position: 'relative',
    '&::before': {
      content: '""',
      width: 0,
      height: 0,
      borderLeft: '0.4em solid transparent',
      borderRight: '0.4em solid transparent',
      borderTop: '0.7em solid #FF0000',
      marginRight: 3,
      marginBottom: '1px',
    }
  },
  accordion: {
    boxShadow: 'none !important',
    background: 'none !important',
    borderBottom: '1px dashed rgba(0, 0, 0, 0.12)',
    borderRadius: '0 !important',
    paddingBottom: 10,
    paddingTop: 8,
    '@media screen and (min-width: 960px)': {
      display: 'none'
    },
    '& .MuiAccordionDetails-root': {
      padding: 0
    },
    '& .MuiButtonBase-root': {
      height: 32,
      minHeight: 32
    },
    '& .MuiAccordionSummary-root': {
      padding: 0,
      marginLeft: '-10px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 14
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: 10,
      order: 2,
      fontWeight: 'bold',
      padding: 0,
      fontSize: '14px',
      color: '#606060',
      fontFamily: 'CO-Bold',
    },
    '& .MuiTouchRipple-root':{
      display: 'none',
    },

  },

})

interface ResultadoFinancieroBase {
  Titulo: string;
  Value: string;
  Unidad: string;
  Variacion: string;
}

interface ResultadoFinanciero {
  Salida: {
    Consolidado: ResultadoFinancieroBase;
    Volumen: ResultadoFinancieroBase;
    Titulo: string;
    Ocultar: boolean;
  }
}

const Content = () => {
  const classes = useStyles();
  let data,error;
  let { mostrarResultadosFinancieros } = React.useContext(PortalContext);
  if (mostrarResultadosFinancieros){
    const response = useSWR<ResultadoFinanciero>("resultadosFinancieros", () => api.post("/be/resultadosfinancieros/", {Entrada:{}}))
    data = response.data;
    error = response.error;
  }

  if(error && error?.message){
    throw new Error(error.message);
  }

  const resultadoFinancieroPanel = (
    <div className={classes.root}>
      {data && data.Salida && <div className={classes.titulo}>{data.Salida?.Titulo}</div> }
      {data && data.Salida && data.Salida.Consolidado && <div className={classes.menuSeccion}>
        <div className={classes.linea}>{data?.Salida?.Consolidado?.Titulo}</div>
        <div className={classes.monto}>{`${data?.Salida?.Consolidado?.Value} ${data?.Salida?.Consolidado?.Unidad}`} </div>
        <div className={`${classes.linea} ${data?.Salida?.Consolidado?.Variacion.includes('+')?classes.positive:classes.negative}`}>{data?.Salida?.Consolidado.Variacion}</div>
      </div>}
      {data && data.Salida && data.Salida.Volumen && <div className={classes.menuSeccion}>
        <div className={classes.linea}>{data?.Salida?.Volumen?.Titulo}</div>
        <div className={classes.linea}>{`${data?.Salida?.Volumen?.Value} ${data?.Salida?.Volumen?.Unidad}`}</div>
        <div className={`${classes.linea} ${data?.Salida?.Volumen?.Variacion.includes('+')?classes.positive:classes.negative}`}>{data?.Salida?.Volumen?.Variacion}</div>
      </div>}
      <iframe src="https://tools.eurolandir.com/tools/ticker/html/?companycode=es-gco&amp;v=static&amp;lang=es-es" scrolling="no" style={{ background: "transparent", minWidth: "245px", width: "1px", maxHeight: "none", minHeight: "0px", height: "16px", border: "0px", right: "0px" }}></iframe>
    </div>
  );

  return (
    <React.Fragment>
      { !mostrarResultadosFinancieros? null :    
        <React.Fragment>
          <Accordion className={classes.accordion}>
            <AccordionSummary
              expandIcon={<IconAbajo />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              Resultados financieros
            </AccordionSummary>
            <AccordionDetails>
              {resultadoFinancieroPanel}
            </AccordionDetails>
          </Accordion>
          <div className={classes.rootPanel}>{resultadoFinancieroPanel}</div>
        </React.Fragment>
      }
    </React.Fragment>
  );
}

export const ResultadoFinanciero = () => {
  return <Content />
}